/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RoleType,
    RoleTypeFromJSON,
    RoleTypeFromJSONTyped,
    RoleTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiRole
 */
export interface ApiRole {
    /**
     * 
     * @type {string}
     * @memberof ApiRole
     */
    id: string;
    /**
     * 
     * @type {RoleType}
     * @memberof ApiRole
     */
    type: RoleType;
}

export function ApiRoleFromJSON(json: any): ApiRole {
    return ApiRoleFromJSONTyped(json, false);
}

export function ApiRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': RoleTypeFromJSON(json['type']),
    };
}

export function ApiRoleToJSON(value?: ApiRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': RoleTypeToJSON(value.type),
    };
}

